import React from "react";
import { Link } from "react-router-dom";
import { Box } from "@material-ui/core";
import { basePath, providerBaseRoutes } from "base-routes";
import "./PatientTabs.css";

const PatientTabs = ({ activeTab }) => {
  return (
    <Box className="patient-tabs-container">
      <div className="patient-tabs">
        <Link
          to={basePath + providerBaseRoutes.patientList.path}
          className={`patient-tab ${activeTab === "referrals" ? "active" : ""}`}
        >
          MAXMRJ Referrals
        </Link>
        <Link
          to={basePath + providerBaseRoutes.myPatients.path}
          className={`patient-tab ${
            activeTab === "myPatients" ? "active" : ""
          }`}
        >
          Other Referrals
        </Link>
      </div>
    </Box>
  );
};

export default PatientTabs;
